<div class="loader">
	<div class="loader__message">
		{{ message || defaultMessage }}
	</div>
	<ion-progress-bar type="indeterminate"></ion-progress-bar>
</div>
